import { getText } from 'utils/stringUtil';
import {
  AUTH_ERROR_INVALID_DOMAIN,
  AUTH_ERROR_PLAN_NOT_FOUND,
  AUTH_ERROR_TOKEN_NOT_FOUND,
  AUTH_ERROR_TOKEN_EXPIRED,
  AUTH_ERROR_TOKEN_EXPIRED_RESET,
  AUTH_ERROR_INVALID_EMAIL,
  AUTH_ERROR_LOGIN_EXISTS,
  AUTH_ERROR_TOKEN_CLAIMED,
  AUTH_ERROR_INVALID_CREDENTIALS,
  AUTH_ERROR_LOGIN_COMPROMISED,
  AUTH_ERROR_PERMISSION_DENIED,
  AUTH_ERROR_INTERNAL_ERROR,
  AUTH_ERROR_EMPLOYEE_SIGN_ERROR,
  AUTH_ERROR_PWDRESET_INFO,
  AUTH_ERROR_INVALID_LOGIN_TYPE,
  AUTH_ERROR_UNKNOWN_ERROR,
  AUTH_ERROR_SSO_EXISTS,
  AUTH_ERROR_EMPLOYEE_NOT_FOUND,
  AUTH_ERROR_PLAN_NOT_MATCHED,
  AUTH_ERROR_INACTIVE_USER,
} from 'constants/languageConstants';

export const getAuthErrorCodes = (
  language: 'ENGLISH' | 'SPANISH' = 'ENGLISH'
) => ({
  INVALID_DOMAIN: {
    code: 'invalid.username.domain',
    type: 'error',
    message: getText(AUTH_ERROR_INVALID_DOMAIN, language),
  },
  PLAN_NOT_FOUND: {
    code: 'plan.not.found',
    type: 'error',
    message: getText(AUTH_ERROR_PLAN_NOT_FOUND, language),
  },
  TOKEN_NOT_FOUND: {
    code: 'token.not.found',
    type: 'warning',
    message: getText(AUTH_ERROR_TOKEN_NOT_FOUND, language),
  },
  TOKEN_EXPIRED: {
    code: 'token.expired',
    type: 'error',
    message: getText(AUTH_ERROR_TOKEN_EXPIRED, language),
  },
  TOKEN_EXPIRED_RESET: {
    code: 'token.expired.reset',
    type: 'error',
    message: getText(AUTH_ERROR_TOKEN_EXPIRED_RESET, language),
  },
  INVALID_EMAIL: {
    code: 'invalid.email',
    type: 'error',
    message: getText(AUTH_ERROR_INVALID_EMAIL, language),
  },
  LOGIN_EXISTS: {
    code: 'existing.login.found',
    type: 'warning',
    message: getText(AUTH_ERROR_LOGIN_EXISTS, language),
  },
  TOKEN_CLAIMED: {
    code: 'token.claimed',
    type: 'warning',
    message: getText(AUTH_ERROR_TOKEN_CLAIMED, language),
  },
  INACTIVE_USER: {
    code: 'invalid.login.status',
    type: 'warning',
    message: getText(AUTH_ERROR_INACTIVE_USER, language),
  },
  LOGIN_NOT_FOUND: {
    code: 'login.not.found',
    type: 'warning',
    message: getText(AUTH_ERROR_INACTIVE_USER, language),
  },
  INVALID_CREDENTIALS: {
    code: 'invalid_grant',
    type: 'error',
    message: getText(AUTH_ERROR_INVALID_CREDENTIALS, language),
  },
  LOGIN_COMPROMISED: {
    code: 'invalid.password.compromised',
    type: 'error',
    message: getText(AUTH_ERROR_LOGIN_COMPROMISED, language),
  },
  PERMISSION_DENIED: {
    code: 'permission.denied',
    type: 'error',
    message: getText(AUTH_ERROR_PERMISSION_DENIED, language),
  },
  INTERNAL_ERROR: {
    code: 'internal.error',
    type: 'error',
    message: getText(AUTH_ERROR_INTERNAL_ERROR, language),
  },
  EMPLOYEE_SIGN_ERROR: {
    code: 'An error occurred while signing up the employee',
    type: 'error',
    message: getText(AUTH_ERROR_EMPLOYEE_SIGN_ERROR, language),
  },
  PWDRESET_INFO: {
    type: 'info',
    message: getText(AUTH_ERROR_PWDRESET_INFO, language),
  },
  INVALID_LOGIN_TYPE: {
    code: 'invalid.login.type',
    type: 'error',
    message: getText(AUTH_ERROR_INVALID_LOGIN_TYPE, language),
  },
  ER_ADMIN_EXISTS: {
    code: 'er.admin.individual.exists',
  },
  UNKNOWN_ERROR: {
    type: 'error',
    message: getText(AUTH_ERROR_UNKNOWN_ERROR, language),
  },
  SSO_EXISITS: {
    code: 'er.admin.individual.with.sso.enabled.exists',
    type: 'error',
    message: getText(AUTH_ERROR_SSO_EXISTS, language),
  },
  EMPLOYEE_NOT_FOUND: {
    code: 'employee.not.found',
    type: 'error',
    message: getText(AUTH_ERROR_EMPLOYEE_NOT_FOUND, language),
  },
  PLAN_NOT_MATCHED: {
    type: 'info',
    message: getText(AUTH_ERROR_PLAN_NOT_MATCHED, language),
  },
});

// For backward compatibility, keep the original export as a default English version
export const AuthErrorCodes = getAuthErrorCodes('ENGLISH');
